import moment from 'moment';
import _ from 'lodash';

export const responsabileareaInitialValues = {
  id: '',
  ragioneSociale: '',
  partitaiva: '', // Presente ? Camelcase ?
  indirizzoCompleto: '', // Indirizzo completo sede legale
  comune: '', // Comune sede legale
  provincia: '', // Provincia sede legale
  regione: '', // Regione sede legale
  cap: '', // CAP sede legale
  indirizzo: '', // Via e numero sede legale
  rea: '',
  registroImprese: '', // Comune + (prov) come stringa
  codiceAttivita: '',
  anagrafica: '', // Id anagrafica collegata
  contratto_id: '', // eslint-disable-line
  contratto_numero: '', // eslint-disable-line
  contratto_dataDecorrenza: '', // eslint-disable-line
  contratto_dataRescissione: '', // eslint-disable-line
  // contratto_collaboratore: newValues._embedded.contratto.collaboratore,
  contratto_attivo: false, // eslint-disable-line
  agenziekiron: [], // Array di ID
};

export const mapToResponsabileareaInitialValues = (newValues) => {
  const mappedValues = {
    id: newValues.id || '',
    ragioneSociale: newValues.ragioneSociale || '',
    partitaiva: newValues.partitaiva || '', // Presente ? Camelcase ?
    indirizzoCompleto: newValues.indirizzoCompleto || '', // Indirizzo completo sede legale
    comune: newValues.comune || '', // Comune sede legale
    provincia: newValues.provincia || '', // Provincia sede legale
    regione: newValues.regione || '', // Regione sede legale
    cap: newValues.cap || '', // CAP sede legale
    indirizzo: newValues.indirizzo || '', // Via e numero sede legale
    rea: newValues.rea || '',
    registroImprese: newValues.registroImprese || '', // Comune + (prov) come stringa
    codiceAttivita: newValues.codiceAttivita || '',
    anagrafica: _.get(newValues, '_embedded.anagrafica.id') || '', // Id anagrafica collegata
    contratto_id: newValues._embedded.contratto ? newValues._embedded.contratto.id : '', // eslint-disable-line
    contratto_numero: newValues._embedded.contratto? newValues._embedded.contratto.numero : '', // eslint-disable-line
    contratto_dataDecorrenza: _.get(newValues, '_embedded.contratto.dataDecorrenza') ?  moment.unix(newValues._embedded.contratto.dataDecorrenza) : '', // eslint-disable-line
    contratto_dataRescissione: _.get(newValues, '_embedded.contratto.dataRescissione') ? moment.unix(newValues._embedded.contratto.dataRescissione) : '', // eslint-disable-line
    // contratto_collaboratore: newValues._embedded.contratto.collaboratore,
    contratto_attivo: newValues._embedded.contratto ? newValues._embedded.contratto.attivo : false, // eslint-disable-line
    agenziekiron: newValues.agenziekiron || [], // Array di ID
  };

  return mappedValues;
};

export default responsabileareaInitialValues;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/ResponsabileArea/initialValues.js